module.exports = __webpack_public_path__ + "img/logo_01.c82d6e98.svg";